if (!customElements.get("color-swatch")) {
  customElements.define(
    "color-swatch",
    class ColorSwatch extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.initialize();
      }

      initialize() {
        this._initializing = true;
        this.initProperites();
        this.initGallery();
        this.initButtons();
        this.initCounter();
        this._initializing = false;
      }

      disconnectedCallback() {
        this._galleryIO?.disconnect();
        if (this._galleryRaf) cancelAnimationFrame(this._galleryRaf);
      }

      initProperites() {
        const node = this;
        this.isProductVariations = node.dataset.productVariations === '';
        this.areFiltersActive = node.dataset.activeFilters === '';
        this.container = node.querySelector(".card__container");
        this.adnotation = node.querySelector(".card");
        this.titleAdnotation = node.querySelector(".card__title a");
        this.color_swatcher_container = this.container.querySelector(
          ".card__color-swatcher--container",
        );
        this.color_swatcher_wrappers = this.container.querySelectorAll(
          ".color-swatcher--wrapper",
        );
        this.color_swatcher_counter = this.container.querySelector(
          ".color-swatcher--counter",
        );
        [this.img, this.hover_img] =
        this.container.querySelectorAll(".card__img");
        this.titleEl = node.querySelector(".card__title");
        this.video = this.querySelector("video");
        this.clicked_href = this.adnotation.getAttribute("href");
        this.clicked_img = this.img?.getAttribute("src");
        this.clicked_srcset = this.img?.getAttribute("srcset");
        this.clicked_hover_img = this.hover_img?.getAttribute("src");
        this.clicked_hover_srcset= this.hover_img?.getAttribute("srcset");
        this.imageSizes = this.img?.getAttribute("sizes") || "(min-width: 1000px) 620px, 100vw";
        this.quickAdds = this.querySelectorAll("quick-add");

        this.loader = this.querySelector(".card__loader");

        
        this.optionsAsColorSwatches = this.color_swatcher_container?.dataset.optionsAsColorSwatches?.split(",") || [];
      }

      initCounter() {
        if (this.color_swatcher_wrappers?.length > 4) {
          this.color_swatcher_counter.innerHTML += `+ ${this.color_swatcher_wrappers.length - 4}`;
          this.color_swatcher_container.addEventListener("mouseover", () =>
            this.showAllWrappers(),
          );
        }
      }

      showAllWrappers() {
        this.color_swatcher_wrappers.forEach((wrapper) =>
          wrapper.classList.remove("hidden"),
        );
        this.color_swatcher_counter.classList.add("hidden");
      }

      initButtons() {
        this.isCheckedOption = 0;
        this.isCheckedActiveFilter = false;
        
        if (this.color_swatcher_wrappers) {
          this.sortButtons();
          this.color_swatcher_wrappers.forEach((wrapper, index) => {
            const button = wrapper.querySelector(".color-swatcher");
            const attributes = this.getButtonAttributes(button);
            const tooltip = wrapper.querySelector(".color-swatcher--tooltip");
            
            if (index > 3) {
              wrapper.classList.add("hidden");
            }
            
            // find filter color and preselect it 
            if(!this.isCheckedActiveFilter){
              const isActiveSwatch = button.dataset.activeSwatch === '';

              if(this.isProductVariations && this.areFiltersActive){
                const currentVariantHandle = this.dataset.currentVariantHandle;
                if(currentVariantHandle === attributes.button_product_handle){
                  this.handleClickEvent(wrapper, attributes)
                  this.isCheckedActiveFilter = true;
                }
              } else if (isActiveSwatch) {
                  this.handleClickEvent(wrapper, attributes)
                  this.isCheckedActiveFilter = true;
              }
          }

            this.assignWrapperEvents(wrapper, attributes, tooltip);
          });
        }

        if (this.color_swatcher_container) {
          this.color_swatcher_container.addEventListener("mouseleave", () =>
            this.restoreAttributes(),
          );
        }
      }

      getButtonAttributes(button) {
        return {
          dataColor: button.getAttribute("data-color"),
          button_href: button.getAttribute("data-href"),
          button_img: button.getAttribute("data-img"),
          button_srcset: button.getAttribute("data-srcset"),
          button_hover: button.getAttribute("data-hover"),
          button_hover_srcset: button.getAttribute("data-hover-srcset"),
          button_product_handle: button.getAttribute("data-product-handle")
        };
      }

      assignWrapperEvents(wrapper, attributes, tooltip) {
        wrapper.addEventListener("click", () =>
          this.handleClickEvent(wrapper, attributes),
        );
        wrapper.addEventListener("keydown", (e) => {
          if (e.key === "Enter") {
            this.handleClickEvent(wrapper, attributes);
          }
        });
        wrapper.addEventListener("mouseover", () =>
          this.handleMouseOverEvent(wrapper, attributes, tooltip),
        );
        wrapper.addEventListener("mouseout", () =>
          this.handleMouseOutEvent(tooltip),
        );
      }

      handleClickEvent(
        wrapper,
        { button_href, button_img, button_hover, button_srcset, button_hover_srcset, button_product_handle },
      ) {
        if(!button_img) return

        this.showLoader();
        this.img.classList.remove("hidden");
        this.img.onload = () => {
          this.hideLoader();
          this.img.onload = null;
        };

        this.setAttributes(this.adnotation, { href: button_href });
        this.setAttributes(this.img, { src: button_img });
        this.setAttributes(this.img, { srcset: button_srcset });
        this.setAttributes(this.adnotation, { href: button_href });
        this.setAttributes(this.titleAdnotation, { href: button_href });

        this.quickAdds?.forEach((quickAdd) => {
          quickAdd.setAttribute("data-product-handle", button_product_handle);
          quickAdd.querySelector("button").dataset.productUrl = button_href;
        });

        if(this.price) this.price.innerHTML = button_price;
        this.checkHoverImage(button_hover, button_hover_srcset);
        this.color_swatcher_wrappers.forEach((wrap) => {
          wrap.classList.remove("active");
        });
        this.clicked_href = button_href;
        this.clicked_img = button_img;
        this.clicked_srcset = button_srcset;
        this.clicked_hover_img = button_hover;
        this.clicked_hover_srcset = button_hover_srcset;
        wrapper.classList.add("active");

        this.video?.classList.add("hidden");
        this.isVideoHidden = true;

        // Colour picked -> rebuild the card gallery to this colour's photos (skipped during
        // init preselection so the gallery still builds lazily on first engage).
        if (this.galleryTrack && !this._initializing) this.buildGallery(true);
      }

      showLoader() {
        this.loader.classList.remove("hidden");
        this.loader.innerHTML = '<div class="spinner-ring"></div>';
        if (!this.img) return;
        this.img.style.opacity = 0;
      }

      hideLoader() {
        this.loader.classList.add("hidden");
        this.loader.innerHTML = "";
        if (!this.img) return;
        this.img.style.opacity = 1;
      }

      handleMouseOverEvent(
        wrapper,
        { button_href, button_img, button_hover, button_srcset, button_hover_srcset },
        tooltip,
      ) {
        if(!this.img?.src?.includes(button_img) || this.img?.classList.contains("hidden")){
        this.showLoader();
        this.img.classList.remove("hidden");
        this.img.onload = () => {
          this.hideLoader();
          this.img.onload = null;
        };

        this.setAttributes(this.adnotation, { href: button_href });
        this.setAttributes(this.img, { src: button_img });
        this.setAttributes(this.img, { srcset: button_srcset });
        this.setAttributes(this.titleAdnotation, { href: button_href });
      }

        this.checkHoverImage(button_hover, button_hover_srcset);
        tooltip.classList.remove("hidden");
        this.setTooltipPosition(tooltip);
      }

      handleMouseOutEvent(tooltip) {
        tooltip.classList.add("hidden");
        tooltip.classList.remove(
          "color-swatcher--tooltip-left",
          "color-swatcher--tooltip-right",
        );
      }

      setTooltipPosition(tooltip) {
        const coords = tooltip.getBoundingClientRect();
        const screenWidth = window.innerWidth;

        if (!coords) return;

        if (coords.x < 0) {
          tooltip.classList.add("color-swatcher--tooltip-left");
        } else if (coords.right > screenWidth) {
          tooltip.classList.add("color-swatcher--tooltip-right");
        }
      }

      setFirstOptionActive() {
        const wrapper = this.color_swatcher_wrappers[0];
        if (wrapper) {
          const button = wrapper.querySelector(".color-swatcher");
          const attributes = this.getButtonAttributes(button);
          this.setAttributes(this.adnotation, { href: attributes.button_href });
          this.setAttributes(this.titleAdnotation, { href: attributes.button_href });
          this.setAttributes(this.img, { src: attributes.button_img });
          this.setAttributes(this.img, { srcset: attributes.button_srcset });
          this.checkHoverImage(attributes.button_hover, attributes.button_hover_srcset);
          wrapper.classList.add("active");
        }
      }

      restoreAttributes() {
        this.setAttributes(this.adnotation, { href: this.clicked_href });
        this.setAttributes(this.titleAdnotation, { href: this.clicked_href });
        this.setAttributes(this.img, { src: this.clicked_img });
        this.setAttributes(this.img, { srcset: this.clicked_srcset });
        this.checkHoverImage(this.clicked_hover_img, this.clicked_hover_srcset);
      }

      sortButtons() {
        if (this.color_swatcher_wrappers) {
          const newArr = Array.from(this.color_swatcher_wrappers).sort(
            (a, b) => {
              const classA = a.classList?.contains("unavailable");
              const classB = b.classList?.contains("unavailable");
              return classA && !classB ? 1 : !classA && classB ? -1 : 0;
            },
          );

          if (this.color_swatcher_container) {
            this.color_swatcher_container.innerHTML = "";
          }

          newArr.forEach((el) => this.color_swatcher_container.append(el));
          this.createCounterSpan();
          this.color_swatcher_wrappers = this.container.querySelectorAll(
            ".color-swatcher--wrapper",
          );
          this.color_swatcher_counter = this.container.querySelector(
            ".color-swatcher--counter",
          );
        }
      }

      createCounterSpan() {
        const counter_span = document.createElement("span");
        counter_span.classList.add("color-swatcher--counter");
        this.color_swatcher_container?.appendChild(counter_span);
      }

      setAttributes(element, attrs) {
        for (let key in attrs) {
          element?.setAttribute(key, attrs[key]);
        }
      }

      checkHoverImage(button_hover, button_hover_srcset) {
        if (button_hover && this.hover_img) {
          this.setAttributes(this.hover_img, { src: button_hover });
          if (button_hover_srcset) {
            this.setAttributes(this.hover_img, { srcset: button_hover_srcset });
          }
        }
      }

      // ---- Card gallery (light native scroll-snap, colour-aware) ----------------------------
      // Slide 1 is the SSR featured image (this.img); the rest of the active colour's photos are
      // injected lazily on first engage (hover / near-viewport / touch) and rebuilt on colour
      // change. No slider library: the browser's own scroll-snap does the swipe.
      initGallery() {
        this.galleryTrack = this.querySelector("[data-card-gallery-track]");
        if (!this.galleryTrack) return;
        this.galleryDots = this.querySelector("[data-card-gallery-dots]");
        this.galleryPrev = this.querySelector(".card__gallery-arrow--prev");
        this.galleryNext = this.querySelector(".card__gallery-arrow--next");
        this.pictureContainer = this.querySelector(".card__picture-container");
        this.galleryBuilt = false;
        this.galleryRTL =
          getComputedStyle(this.galleryTrack).direction === "rtl" ||
          document.documentElement.dir === "rtl";

        const engage = () => this.buildGallery();
        this.pictureContainer?.addEventListener("pointerenter", engage, { once: true });
        this.galleryTrack.addEventListener("touchstart", engage, { once: true, passive: true });
        if ("IntersectionObserver" in window) {
          this._galleryIO = new IntersectionObserver(
            (entries) => {
              if (entries.some((e) => e.isIntersecting)) {
                this.buildGallery();
                this._galleryIO.disconnect();
              }
            },
            { rootMargin: "200px" },
          );
          this._galleryIO.observe(this.galleryTrack);
        }

        this.galleryPrev?.addEventListener("click", (e) => {
          e.preventDefault();
          this.galleryStep(-1);
        });
        this.galleryNext?.addEventListener("click", (e) => {
          e.preventDefault();
          this.galleryStep(1);
        });
        this.galleryDots?.addEventListener("click", (e) => {
          const dot = e.target.closest("[data-gallery-dot]");
          if (!dot) return;
          e.preventDefault();
          this.galleryGoTo(Number(dot.dataset.galleryDot));
        });
        this.galleryTrack.addEventListener(
          "scroll",
          () => {
            if (this._galleryRaf) return;
            this._galleryRaf = requestAnimationFrame(() => {
              this._galleryRaf = null;
              this.updateGalleryDots();
            });
          },
          { passive: true },
        );
      }

      activeSwatchGallery() {
        let wrapper = this.container?.querySelector(".color-swatcher--wrapper.active");
        if (!wrapper) wrapper = this.color_swatcher_wrappers?.[0];
        const btn = wrapper?.querySelector(".color-swatcher");
        return (btn?.getAttribute("data-gallery") || "").split(/\s+/).filter(Boolean);
      }

      buildGallery(force) {
        if (!this.galleryTrack) return;
        if (this.galleryBuilt && !force) return;

        const urls = this.activeSwatchGallery();
        if (urls.length === 0) {
          // No colour-swatch data (locales without swatches, or single-colour products): keep the
          // SSR slides (featured + secondary fallback) exactly as rendered.
          this.galleryBuilt = true;
          this.refreshGalleryChrome();
          return;
        }
        const firstPath = this.pathOf(this.img?.getAttribute("src") || "");
        this.galleryTrack
          .querySelectorAll("[data-gallery-injected], [data-gallery-ssr]")
          .forEach((n) => n.remove());

        const frag = document.createDocumentFragment();
        const alt = this.gallerySlideAlt();
        urls.forEach((u) => {
          if (this.pathOf(u) === firstPath) return; // never duplicate slide 1 (featured)
          const slide = document.createElement("div");
          slide.className = "card__gallery-slide";
          slide.setAttribute("data-gallery-injected", "");
          const img = document.createElement("img");
          img.className = "card__img";
          img.loading = "lazy";
          img.decoding = "async";
          img.src = this.galleryUrl(u, 750);
          img.srcset = this.buildSrcset(u);
          img.sizes = this.imageSizes;
          img.alt = alt;
          slide.appendChild(img);
          frag.appendChild(slide);
        });
        this.galleryTrack.appendChild(frag);
        this.galleryBuilt = true;
        this.galleryTrack.scrollTo({ left: 0, behavior: "auto" });
        this.refreshGalleryChrome();
      }

      refreshGalleryChrome() {
        const count = this.galleryTrack.querySelectorAll(".card__gallery-slide").length;
        this.pictureContainer?.classList.toggle("card__picture-container--gallery-ready", count > 0);
        this.pictureContainer?.classList.toggle("card__picture-container--gallery-multi", count > 1);
        if (!this.galleryDots) return;
        this.galleryDots.innerHTML = "";
        if (count <= 1) return;
        for (let i = 0; i < count; i++) {
          const dot = document.createElement("button");
          dot.type = "button";
          dot.className = "card__gallery-dot" + (i === 0 ? " card__gallery-dot--active" : "");
          dot.tabIndex = -1;
          dot.setAttribute("data-gallery-dot", i);
          this.galleryDots.appendChild(dot);
        }
      }

      slideWidth() {
        return this.galleryTrack.clientWidth || 1;
      }

      currentSlideIndex() {
        return Math.round(Math.abs(this.galleryTrack.scrollLeft) / this.slideWidth());
      }

      galleryStep(dir) {
        /* Loop (Tsoulfa 2026-07-11): past the last photo wraps to the first and
           back, so the arrows never dead-end; the dots carry the "where am I"
           signal. A smooth scroll on the wrap would rewind through every slide,
           so the wrap is a 150ms crossfade over an instant jump instead. */
        const count = this.galleryTrack.querySelectorAll(".card__gallery-slide").length;
        if (count < 2 || this._galleryFading) return;
        let next = this.currentSlideIndex() + dir;
        const wrapping = next < 0 || next >= count;
        next = (next + count) % count;
        const left = (this.galleryRTL ? -1 : 1) * next * this.slideWidth();
        const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (!wrapping || reduce) {
          this.galleryTrack.scrollTo({ left, behavior: reduce ? "auto" : "smooth" });
          return;
        }
        const track = this.galleryTrack;
        this._galleryFading = true;
        track.style.transition = "opacity 150ms ease-out";
        track.style.opacity = "0";
        setTimeout(() => {
          track.scrollTo({ left, behavior: "auto" });
          requestAnimationFrame(() => {
            track.style.opacity = "1";
            setTimeout(() => {
              track.style.transition = "";
              this._galleryFading = false;
            }, 180);
          });
        }, 160);
      }

      galleryGoTo(i) {
        const left = (this.galleryRTL ? -1 : 1) * i * this.slideWidth();
        this.galleryTrack.scrollTo({ left, behavior: this.galleryBehavior() });
      }

      updateGalleryDots() {
        if (!this.galleryDots) return;
        const idx = this.currentSlideIndex();
        this.galleryDots
          .querySelectorAll(".card__gallery-dot")
          .forEach((d, i) => d.classList.toggle("card__gallery-dot--active", i === idx));
      }

      galleryBehavior() {
        return window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
      }

      galleryUrl(u, w) {
        return u.replace(/([?&])width=\d+/, "$1width=" + w);
      }

      buildSrcset(u) {
        return [240, 320, 375, 480, 640, 750, 800, 900, 1000, 1440]
          .map((w) => this.galleryUrl(u, w) + " " + w + "w")
          .join(", ");
      }

      pathOf(src) {
        return (src || "").split("?")[0];
      }

      gallerySlideAlt() {
        const t = this.titleAdnotation?.textContent?.trim() || this.titleEl?.textContent?.trim() || "";
        const c =
          this.container
            ?.querySelector(".color-swatcher--wrapper.active .color-swatcher")
            ?.getAttribute("data-color") || "";
        return c ? t + ", " + c : t;
      }
    },
  );
}
